module.exports = "<header></header>\r\n\r\n<div id=\"home\" ng-include=\"'panels/home.html'\"></div>\r\n\r\n<!-- <carousel id=\"services\" templates=\"['panels/engineering.html', 'panels/computer-aided-design.html', 'panels/procurement.html', 'panels/construction-management.html']\"></carousel> -->\r\n\r\n<!-- <carousel id=\"expertise\" templates=\"['panels/substation.html', 'panels/lighting-systems.html', 'panels/renewable-energy.html']\"></carousel> -->\r\n\r\n<div id=\"contact\" ng-include=\"'panels/contact.html'\"></div>"


/*****************
 ** WEBPACK FOOTER
 ** ./app/app-component.html
 ** module id = 17
 ** module chunks = 0
 **/